// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","appMode":"Loader_appMode__u4Dqx"};